export default "__VITE_ASSET__DLgKuL6b__"